import { BoardParams } from './board.types';

// Tableros tipo 'params': la URL guardada en `urlBi` trae placeholders
// {{clave}} que se llenan con parameters[uid] del usuario logueado.
// Ej. "https://app/?uuid={{uid}}" + { uid: "41e2..." } → "https://app/?uuid=41e2...".
const PLACEHOLDER = /\{\{\s*([\w.-]+)\s*\}\}/g;

// Claves {{...}} que usa la URL, sin repetir. Al crear el tablero se registran en
// parameters_objects para poder asignarlas por usuario y exigirlas en el listado.
export function getUrlTemplateKeys(template: string): string[] {
  const claves = [...(template ?? '').matchAll(PLACEHOLDER)].map(m => m[1]);
  return [...new Set(claves)];
}

export type ResolvedUrl = {
  url: string | null; // null si falta algun parametro: no se debe cargar la URL a medias
  missing: string[];
};

export function resolveUrlTemplate(template: string, params: BoardParams): ResolvedUrl {
  const missing: string[] = [];
  const url = (template ?? '').replace(PLACEHOLDER, (_, clave: string) => {
    const valor = params[clave];
    if (valor === undefined || valor === null || String(valor).trim() === '') {
      if (!missing.includes(clave)) missing.push(clave);
      return '';
    }
    return encodeURIComponent(String(valor).trim());
  });
  return { url: missing.length ? null : url, missing };
}
